import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminMain from "../component/layout/AdminMain";
import AdminActivity from "../component/admin/master-data/activity/AdminActivity";
import AdminBank from "../component/admin/master-data/bank/AdminBank";
import AdminEmployee from "../component/admin/master-data/employee/AdminEmployee";
import AdminEmployeeEdit from "../component/admin/master-data/employee/AdminEmployeeEdit";
import AdminEmployeeTambah from "../component/admin/master-data/employee/AdminEmployeeTambah";
import AdminJobPosition from "../component/admin/master-data/jobPosition/AdminJobPosition";
import AdminPriceType from "../component/admin/master-data/priceType/AdminPriceType";
import AdminRole from "../component/admin/master-data/role/AdminRole";
import AdminUnitWeight from "../component/admin/master-data/unitWeight/AdminUnitWeight";
import AdminVegetable from "../component/admin/master-data/vegetable/AdminVegetable";
import AdminVegetableDetail from "../component/admin/master-data/vegetable/AdminVegetableDetail";
import AdminVegetableEdit from "../component/admin/master-data/vegetable/AdminVegetableEdit";
import AdminVegetableTambah from "../component/admin/master-data/vegetable/AdminVegetableTambah";
import AdminVegetablePrice from "../component/admin/master-data/vegetablePrice/AdminVegetablePrice";
import AdminVegetablePriceDetail from "../component/admin/master-data/vegetablePrice/AdminVegetablePriceDetail";
import AdminVegetablePriceEdit from "../component/admin/master-data/vegetablePrice/AdminVegetablePriceEdit";
import AdminVegetablePriceTambah from "../component/admin/master-data/vegetablePrice/AdminVegetablePriceTambah";
import AdminVegetableType from "../component/admin/master-data/vegetableType/AdminVegetableType";
import AdminWorkingArea from "../component/admin/master-data/workingArea/AdminWorkingArea";
import AdminWorkingStatus from "../component/admin/master-data/workingStatus/AdminWorkingStatus";
import UserManagement from "../component/admin/user-management/UserManagement";
import UserManagementTambah from "../component/admin/user-management/UserManagementTambah";
import Login from "../component/login/Login";
import PrivateRoute from "./PrivateRoute";
import UserManagementChangePassword from "../component/admin/user-management/UserManagementChangePassword";
import UserManagamentEdit from "../component/admin/user-management/UserManagementEdit";
import UserManagementDetail from "../component/admin/user-management/UserManagementDetail";
import AdminFarmer from "../component/admin/master-data/farmer/AdminFarmer";
import AdminFarmerTambah from "../component/admin/master-data/farmer/AdminFarmerTambah";
import AdminFarmerEdit from "../component/admin/master-data/farmer/AdminFarmerEdit";
import AdminCustomerGroup from "../component/admin/master-data/customerGroup/AdminCustomerGroup";
import AdminCustomerRegion from "../component/admin/master-data/customerRegion/AdminCustomerRegion";
import AdminGoodsCategory from "../component/admin/master-data/goodsCategory/AdminGoodsCategory";
import AdminGoodsOperational from "../component/admin/master-data/goodsOperational/AdminGoodsOperational";
import AdminGoodsOperationalTambah from "../component/admin/master-data/goodsOperational/AdminGoodsOperationalTambah";
import AdminGoodsOperationalEdit from "../component/admin/master-data/goodsOperational/AdminGoodsOperationalEdit";
import AdminGoodsOperationalDetail from "../component/admin/master-data/goodsOperational/AdminGoodsOperationalDetail";
import AdminDeliveryVehicle from "../component/admin/master-data/deliveryVehicle/AdminDeliveryVehicle";
import AdminDeliveryVehicleTambah from "../component/admin/master-data/deliveryVehicle/AdminDeliveryVehicleTambah";
import AdminDeliveryVehicleEdit from "../component/admin/master-data/deliveryVehicle/AdminDeliveryVehicleEdit";
import AdminDeliveryVehicleDetail from "../component/admin/master-data/deliveryVehicle/AdminDeliveryVehicleDetail";
import AdminCustomer from "../component/admin/master-data/customer/AdminCustomer";
import AdminCustomerTambah from "../component/admin/master-data/customer/AdminCustomerTambah";
import AdminCustomerEdit from "../component/admin/master-data/customer/AdminCustomerEdit";
import AdminCustomerDetail from "../component/admin/master-data/customer/AdminCustomerDetail";
import FarmerDailyActivity from "../component/farmer/dailyActivity/FarmerDailyActivity";
import FarmerDailyActivityTambah from "../component/farmer/dailyActivity/FarmerDailyActivityTambah";
import FarmerDailyActivityEdit from "../component/farmer/dailyActivity/FarmerDailyActivityEdit";
import FarmerDailyActivityDetail from "../component/farmer/dailyActivity/FarmerDailyActivityDetail";
import SpvReportDailyActivity from "../component/supervisor/report/dailyActivityAll/SpvReportDailyActivity";
import SpvReportActivity from "../component/supervisor/report/dailyActivity/SpvReportActivity";
import SpvReportNoActivity from "../component/supervisor/report/dailyNoActivity/SpvReportNoActivity";
import SpvReportActivityDetail from "../component/supervisor/report/dailyActivityDetail/SpvReportActivityDetail";
import FarmerHarvestEstimate from "../component/farmer/harvestEstimate/FarmerHarvestEstimate";
import FarmerHarvestEstimateTambah from "../component/farmer/harvestEstimate/FarmerHarvestEstimateTambah";
import FarmerHarvestEstimateEdit from "../component/farmer/harvestEstimate/FarmerHarvestEstimateEdit";
import FarmerHarvestEstimateDetail from "../component/farmer/harvestEstimate/FarmerHarvestEstimateDetail";
import FarmerHarvest from "../component/farmer/harvest/FarmerHarvest";
import FarmerHarvestTambah from "../component/farmer/harvest/FarmerHarvestTambah";
import FarmerHarvestEdit from "../component/farmer/harvest/FarmerHarvestEdit";
import FarmerHarvestDetail from "../component/farmer/harvest/FarmerHarvestDetail";
import FarmerHarvestEstimateDashboard from "../component/farmer/harvestEstimate/FarmerHarvestEstimateDashboard";
import FarmerHarvestDashboardTambah from "../component/farmer/harvest/FarmerHarvestDashboardTambah";
import SpvReportHarvestEstimate from "../component/supervisor/report/harvestEstimate/SpvReportHarvestEstimate";
import SpvReportHarvest from "../component/supervisor/report/harvest/SpvReportHarvest";
import SpvReportHarvestFarmer from "../component/supervisor/report/harvestFarmer/SpvReportHarvestFarmer";
import SpvReportHarvestEstimateFarmer from "../component/supervisor/report/harvestEstimateFarmer/SpvReportHarvestEstimateFarmer";
import AdminPurchaseOrder from "../component/farmer/purchaseOrder/AdminPurchaseOrder";
import AdminPurchaseOrderTambah from "../component/farmer/purchaseOrder/AdminPurchaseOrderTambah";
import AdminPurchaseOrderTerima from "../component/farmer/purchaseOrder/AdminPurchaseOrderTerima";
import AdminPurchaseOrderEdit from "../component/farmer/purchaseOrder/AdminPurchaseOrderEdit";
import AdminPurchaseOrderDetail from "../component/farmer/purchaseOrder/AdminPurchaseOrderDetail";
import AdminPurchaseOrderCust from "../component/admin/purchaseOrderCust/AdminPurchaseOrderCust";
import AdminPurchaseOrderCustTambah from "../component/admin/purchaseOrderCust/AdminPurchaseOrderCustTambah";
import AdminPurchaseOrderCustTerima from "../component/admin/purchaseOrderCust/AdminPurchaseOrderCustTerima";
import AdminPurchaseOrderCustEdit from "../component/admin/purchaseOrderCust/AdminPurchaseOrderCustEdit";
import AdminPurchaseOrderCustDetail from "../component/admin/purchaseOrderCust/AdminPurchaseOrderCustDetail";
import AdminStockVegetables from "../component/admin/stock-vegetables/AdminStockVegetables";
import AdminStockVegetablesTambah from "../component/admin/stock-vegetables/AdminStockVegetablesTambah";
import AdminStockVegetablesEdit from "../component/admin/stock-vegetables/AdminStockVegetablesEdit";
import AdminStockVegetablesDetail from "../component/admin/stock-vegetables/AdminStockVegetablesDetail";
import AdminStockOperationalGoods from "../component/admin/stock-operational-goods/AdminStockOperationalGoods";
import AdminStockOperationalGoodsTambah from "../component/admin/stock-operational-goods/AdminStockOperationalGoodsTambah";
import AdminStockOperationalGoodsEdit from "../component/admin/stock-operational-goods/AdminStockOperationalGoodsEdit";
import AdminStockOperationalGoodsDetail from "../component/admin/stock-operational-goods/AdminStockOperationalGoodsDetail";
import AdminDeliveryOrder from "../component/admin/delivery-order/AdminDeliveryOrder";
import AdminDeliveryOrderTambah from "../component/admin/delivery-order/AdminDeliveryOrderTambah";
import AdminDeliveryOrderEdit from "../component/admin/delivery-order/AdminDeliveryOrderEdit";
import AdminDeliveryOrderDetail from "../component/admin/delivery-order/AdminDeliveryOrderDetail";
import AdminInvoice from "../component/admin/invoice/AdminInvoice";
import AdminInvoiceTambah from "../component/admin/invoice/AdminInvoiceTambah";
import AdminInvoiceEdit from "../component/admin/invoice/AdminInvoiceEdit";
import AdminInvoiceDetail from "../component/admin/invoice/AdminInvoiceDetail";
import AdminPurchaseOrderToko from "../component/farmer/purchaseOrder/AdminPurchaseOrderToko";
import FarmerDebtPlastic from "../component/farmer/debt-plastic/FarmerDebtPlastic";
import FarmerDebtPlasticTambah from "../component/farmer/debt-plastic/FarmerDebtPlasticTambah";
import FarmerDebtPlasticEdit from "../component/farmer/debt-plastic/FarmerDebtPlasticEdit";
import FarmerDebtPlasticDetail from "../component/farmer/debt-plastic/FarmerDebtPlasticDetail";
import AdminOperationalSubmission from "../component/admin/operational-submission/AdminOperationalSubmission";
import AdminOperationalSubmissionTambah from "../component/admin/operational-submission/AdminOperationalSubmissionTambah";
import AdminOperationalSubmissionEdit from "../component/admin/operational-submission/AdminOperationalSubmissionEdit";
import AdminOperationalSubmissionDetail from "../component/admin/operational-submission/AdminOperationalSubmissionDetail";
import AdminOperationalSubmissionTerima from "../component/admin/operational-submission/AdminOperationalSubmissionTerima";
import FarmerDebtMoney from "../component/farmer/debt-money/FarmerDebtMoney";
import FarmerDebtMoneyTambah from "../component/farmer/debt-money/FarmerDebtMoneyTambah";
import FarmerDebtMoneyEdit from "../component/farmer/debt-money/FarmerDebtMoneyEdit";
import FarmerDebtMoneyDetail from "../component/farmer/debt-money/FarmerDebtMoneyDetail";
import AdminPurchaseOrderFarmer from "../component/admin/purchaseOrderFarmer/AdminPurchaseOrderFarmer";
import AdminPurchaseOrderFarmerTambah from "../component/admin/purchaseOrderFarmer/AdminPurchaseOrderFarmerTambah";

export default function SuperAdminRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminMain />
            </PrivateRoute>
          }
        >
          <Route
            path="/admin/aktifitas"
            element={
              <PrivateRoute>
                <AdminActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/role"
            element={
              <PrivateRoute>
                <AdminRole />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/bank"
            element={
              <PrivateRoute>
                <AdminBank />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/jabatan"
            element={
              <PrivateRoute>
                <AdminJobPosition />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/area"
            element={
              <PrivateRoute>
                <AdminWorkingArea />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/status-karyawan"
            element={
              <PrivateRoute>
                <AdminWorkingStatus />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/karyawan"
            element={
              <PrivateRoute>
                <AdminEmployee />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/karyawan/tambah"
            element={
              <PrivateRoute>
                <AdminEmployeeTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/karyawan/edit/:id"
            element={
              <PrivateRoute>
                <AdminEmployeeEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/karyawan/detail/:id"
            element={
              <PrivateRoute>
                <AdminEmployeeEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/petani"
            element={
              <PrivateRoute>
                <AdminFarmer />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/petani/tambah"
            element={
              <PrivateRoute>
                <AdminFarmerTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/petani/edit/:id"
            element={
              <PrivateRoute>
                <AdminFarmerEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/petani/detail/:id"
            element={
              <PrivateRoute>
                <AdminFarmerEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tipe-harga"
            element={
              <PrivateRoute>
                <AdminPriceType />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/satuan-berat"
            element={
              <PrivateRoute>
                <AdminUnitWeight />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tipe-sayuran"
            element={
              <PrivateRoute>
                <AdminVegetableType />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/sayuran"
            element={
              <PrivateRoute>
                <AdminVegetable />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/sayuran/tambah"
            element={
              <PrivateRoute>
                <AdminVegetableTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/sayuran/edit/:id"
            element={
              <PrivateRoute>
                <AdminVegetableEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/sayuran/detail/:id"
            element={
              <PrivateRoute>
                <AdminVegetableDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/harga-sayuran"
            element={
              <PrivateRoute>
                <AdminVegetablePrice />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/harga-sayuran/tambah"
            element={
              <PrivateRoute>
                <AdminVegetablePriceTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/harga-sayuran/edit/:id"
            element={
              <PrivateRoute>
                <AdminVegetablePriceEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/harga-sayuran/detail/:id"
            element={
              <PrivateRoute>
                <AdminVegetablePriceDetail />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/customer"
            element={
              <PrivateRoute>
                <AdminCustomer />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/customer/tambah"
            element={
              <PrivateRoute>
                <AdminCustomerTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/customer/edit/:id"
            element={
              <PrivateRoute>
                <AdminCustomerEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/customer/detail/:id"
            element={
              <PrivateRoute>
                <AdminCustomerDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/customer-group"
            element={
              <PrivateRoute>
                <AdminCustomerGroup />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/customer-region"
            element={
              <PrivateRoute>
                <AdminCustomerRegion />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/kategori-produk"
            element={
              <PrivateRoute>
                <AdminGoodsCategory />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/produk-operational"
            element={
              <PrivateRoute>
                <AdminGoodsOperational />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/produk-operational/tambah"
            element={
              <PrivateRoute>
                <AdminGoodsOperationalTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/produk-operational/edit/:id"
            element={
              <PrivateRoute>
                <AdminGoodsOperationalEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/produk-operational/detail/:id"
            element={
              <PrivateRoute>
                <AdminGoodsOperationalDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/kendaraan-pengiriman"
            element={
              <PrivateRoute>
                <AdminDeliveryVehicle />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/kendaraan-pengiriman/tambah"
            element={
              <PrivateRoute>
                <AdminDeliveryVehicleTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/kendaraan-pengiriman/edit/:id"
            element={
              <PrivateRoute>
                <AdminDeliveryVehicleEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/kendaraan-pengiriman/detail/:id"
            element={
              <PrivateRoute>
                <AdminDeliveryVehicleDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/user-management"
            element={
              <PrivateRoute>
                <UserManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/user-management/tambah"
            element={
              <PrivateRoute>
                <UserManagementTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/user-management/ubah-password/:id"
            element={
              <PrivateRoute>
                <UserManagementChangePassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/user-management/edit/:id"
            element={
              <PrivateRoute>
                <UserManagamentEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/user-management/detail/:id"
            element={
              <PrivateRoute>
                <UserManagementDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/po-toko"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderCust />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/po-toko/tambah"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderCustTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/po-toko/terima/:id"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderCustTerima />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/po-toko/edit/:id"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderCustEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/po-toko/detail/:id"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderCustDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-sayuran"
            element={
              <PrivateRoute>
                <AdminStockVegetables />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-sayuran/tambah"
            element={
              <PrivateRoute>
                <AdminStockVegetablesTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-sayuran/edit/:id"
            element={
              <PrivateRoute>
                <AdminStockVegetablesEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-sayuran/detail/:id"
            element={
              <PrivateRoute>
                <AdminStockVegetablesDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-barang-operational"
            element={
              <PrivateRoute>
                <AdminStockOperationalGoods />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-barang-operational/tambah"
            element={
              <PrivateRoute>
                <AdminStockOperationalGoodsTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-barang-operational/edit/:id"
            element={
              <PrivateRoute>
                <AdminStockOperationalGoodsEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/stock-barang-operational/detail/:id"
            element={
              <PrivateRoute>
                <AdminStockOperationalGoodsDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/surat-jalan"
            element={
              <PrivateRoute>
                <AdminDeliveryOrder />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/surat-jalan/tambah"
            element={
              <PrivateRoute>
                <AdminDeliveryOrderTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/surat-jalan/edit/:id"
            element={
              <PrivateRoute>
                <AdminDeliveryOrderEdit sjBack={false} />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/surat-jalan/detail/:id"
            element={
              <PrivateRoute>
                <AdminDeliveryOrderDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/surat-jalan/kembali/:id"
            element={
              <PrivateRoute>
                <AdminDeliveryOrderEdit sjBack={true} />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/invoice"
            element={
              <PrivateRoute>
                <AdminInvoice />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/invoice/tambah"
            element={
              <PrivateRoute>
                <AdminInvoiceTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/invoice/edit/:id"
            element={
              <PrivateRoute>
                <AdminInvoiceEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/invoice/detail/:id"
            element={
              <PrivateRoute>
                <AdminInvoiceDetail />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/pengajuan-operasional"
            element={<AdminOperationalSubmission />}
          />
          <Route
            path="/admin/pengajuan-operasional/tambah"
            element={<AdminOperationalSubmissionTambah />}
          />
          <Route
            path="/admin/pengajuan-operasional/edit/:id"
            element={<AdminOperationalSubmissionEdit />}
          />

          <Route
            path="/admin/pengajuan-operasional/detail/:id"
            element={<AdminOperationalSubmissionDetail />}
          />

          <Route
            path="/admin/pengajuan-operasional/terima/:id"
            element={<AdminOperationalSubmissionTerima />}
          />
          <Route
            path="/admin/keuangan/pembayaran-nota"
            element={<AdminPurchaseOrderFarmer />}
          />
          <Route
            path="/admin/keuangan/pembayaran-nota/tambah"
            element={<AdminPurchaseOrderFarmerTambah />}
          />
        </Route>

        <Route
          path="/petani"
          element={
            <PrivateRoute>
              <AdminMain />
            </PrivateRoute>
          }
        >
          <Route
            path="/petani/aktifitas-harian"
            element={
              <PrivateRoute>
                <FarmerDailyActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/aktifitas-harian/tambah"
            element={
              <PrivateRoute>
                <FarmerDailyActivityTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/aktifitas-harian/edit/:id"
            element={
              <PrivateRoute>
                <FarmerDailyActivityEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/aktifitas-harian/detail/:id"
            element={
              <PrivateRoute>
                <FarmerDailyActivityDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/estimasi-panen"
            element={
              <PrivateRoute>
                <FarmerHarvestEstimate />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/estimasi-panen/tambah"
            element={
              <PrivateRoute>
                <FarmerHarvestEstimateTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/estimasi-panen/edit/:id"
            element={
              <PrivateRoute>
                <FarmerHarvestEstimateEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/estimasi-panen/detail/:id"
            element={
              <PrivateRoute>
                <FarmerHarvestEstimateDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/panen"
            element={
              <PrivateRoute>
                <FarmerHarvest />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/panen/tambah"
            element={
              <PrivateRoute>
                <FarmerHarvestTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/panen/dashboard/tambah/:id"
            element={
              <PrivateRoute>
                <FarmerHarvestDashboardTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/panen/edit/:id"
            element={
              <PrivateRoute>
                <FarmerHarvestEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/panen/detail/:id"
            element={
              <PrivateRoute>
                <FarmerHarvestDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/panen/:id"
            element={
              <PrivateRoute>
                <FarmerHarvestDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/panen/dashboard"
            element={
              <PrivateRoute>
                <FarmerHarvestEstimateDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/petani/nota-petani"
            element={
              <PrivateRoute>
                <AdminPurchaseOrder />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/nota-petani/tambah"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/nota-petani/terima/:id"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderTerima />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/nota-petani/terima-toko/:id"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderToko />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/nota-petani/edit/:id"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/nota-petani/detail/:id"
            element={
              <PrivateRoute>
                <AdminPurchaseOrderDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang-plastik"
            element={
              <PrivateRoute>
                <FarmerDebtPlastic />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang-plastik/tambah"
            element={
              <PrivateRoute>
                <FarmerDebtPlasticTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang-plastik/edit/:id"
            element={
              <PrivateRoute>
                <FarmerDebtPlasticEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang-plastik/detail/:id"
            element={
              <PrivateRoute>
                <FarmerDebtPlasticDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang"
            element={
              <PrivateRoute>
                <FarmerDebtMoney />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang/tambah"
            element={
              <PrivateRoute>
                <FarmerDebtMoneyTambah />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang/edit/:id"
            element={
              <PrivateRoute>
                <FarmerDebtMoneyEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/petani/hutang/detail/:id"
            element={
              <PrivateRoute>
                <FarmerDebtMoneyDetail />
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="/spv"
          element={
            <PrivateRoute>
              <AdminMain />
            </PrivateRoute>
          }
        >
          <Route
            path="/spv/laporan/aktifitas-petani"
            element={
              <PrivateRoute>
                <SpvReportDailyActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/aktifitas-petani/beraktifitas"
            element={
              <PrivateRoute>
                <SpvReportActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/aktifitas-petani/tidak-beraktifitas"
            element={
              <PrivateRoute>
                <SpvReportNoActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/aktifitas-petani/detail"
            element={
              <PrivateRoute>
                <SpvReportActivityDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/estimasi-panen"
            element={
              <PrivateRoute>
                <SpvReportHarvestEstimate />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/panen"
            element={
              <PrivateRoute>
                <SpvReportHarvest />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/panen/petani"
            element={
              <PrivateRoute>
                <SpvReportHarvestFarmer />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/estimasi-panen/petani"
            element={
              <PrivateRoute>
                <SpvReportHarvestEstimateFarmer />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
}
